import { useEffect } from 'react'
import { usePoll } from '@inertiajs/react'

import { ImportSummary } from '@components/imports/ImportSummary'
import { PageLayout } from '@components/layouts/PageLayout'
import { type ImportSummaryData, isSettled } from '@utils/imports/import'
import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('imports.summary')

export type GroupImportsShowProps = ImportSummaryData

const POLL_INTERVAL_MS = 5000

export default function GroupImportsShow(summary: GroupImportsShowProps) {
  const settled = isSettled(summary.import.status)

  const { start, stop } = usePoll(POLL_INTERVAL_MS, { only: ['import'] }, { autoStart: false })
  useEffect(() => {
    if (settled) stop()
    else start()
  }, [settled, start, stop])

  return (
    <PageLayout.Root>
      <PageLayout.Header icon="upload-cloud-02" heading={t('heading')} subtitle={t('subtitle')} />
      <PageLayout.Body>
        <div className="tw:flex tw:max-w-5xl tw:flex-col tw:gap-5">
          <ImportSummary {...summary} />
        </div>
      </PageLayout.Body>
    </PageLayout.Root>
  )
}
